import type { ApiError } from "./api.type";

export const isError404 = (error?: ApiError | null) => {
  return error?.response?.status === 404;
};

export const isApiError = (error: unknown): error is ApiError => {
  if (typeof error !== "object" || error === null) return false;

  const err = error as Partial<ApiError>;

  return (
    typeof err.name === "string" &&
    typeof err.message === "string" &&
    typeof err.code === "string" &&
    typeof err.response === "object" &&
    err.response !== null &&
    typeof err.response.status === "number" &&
    typeof err.response.data === "object" &&
    err.response.data !== null &&
    typeof err.response.data.message === "string" &&
    typeof err.response.data.errors === "object" &&
    err.response.data.errors !== null
  );
};
